import ProjectCertificationOptionLayout from './project_certification_option_layout.jsx'

const ProjectCertificationOptionPage = () => {
  return (
      <ProjectCertificationOptionLayout />
  );
};

export default ProjectCertificationOptionPage;